/* eslint-disable no-undef */
/**
 * Apply animations if user has not disabled motion.
 *
 * TODO: review the `gsap` global.
 */

import '@/client/src/components/login/vendor';
import 'slick-carousel';

jQuery(($) => {
  function animatePolygons() {
    const polygons = document.querySelectorAll('.polygon');

    for (const polygon of polygons) {
      var randomX = random(10, 20);
      var randomY = random(20, 30);
      const randomDelay = random(0, 1);
      var randomTime = random(3, 5);
      var randomTime2 = random(5, 10);
      var randomAngle = random(8, 12);
      gsap.set(polygon, {
        x: randomX(-1),
        y: randomX(1),
      });
      moveX(polygon, 1);
      moveY(polygon, -1);
      rotate(polygon, 1);
    }

    function rotate(target, direction) {
      gsap.to(target, randomTime2(), {
        rotation: randomAngle(direction),
        // delay: randomDelay(),
        ease: Sine.easeInOut,
        onComplete: rotate,
        onCompleteParams: [target, direction * -1],
      });
    }

    function moveX(target, direction) {
      gsap.to(target, randomTime(), {
        x: randomX(direction),
        ease: Sine.easeInOut,
        onComplete: moveX,
        onCompleteParams: [target, direction * -1],
      });
    }

    function moveY(target, direction) {
      gsap.to(target, randomTime(), {
        y: randomY(direction),
        ease: Sine.easeInOut,
        onComplete: moveY,
        onCompleteParams: [target, direction * -1],
      });
    }

    function random(min, max) {
      const delta = max - min;
      return (direction = 1) => (min + delta * Math.random()) * direction;
    }
  }

  function componentAnimations() {
    if ($('.wp-block-real-world-learning-audiences').length) {
      const audienceTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.wp-block-real-world-learning-audiences',
          start: 'top center',
        },
      });

      audienceTL.from('.audience-card img', { opacity: 0, scale: 0.5, stagger: 0.125 });
    }

    if ($('.icon-listing-block').length) {
      const iconsTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.icon-listing-block ol',
          start: 'top 80%',
        },
      });

      iconsTL.from('.icon-listing-block .listing-icon img', {
        opacity: 0, scale: 0.5, duration: 0.75, stagger: 0.375,
      });
    }

    if ($('.wp-block-real-world-learning-media.right-image').length) {
      if ($('.wp-block-real-world-learning-media').hasClass('discover-their-potential')) {
        const discoverUnderline = $('#every-double-underline');
        $('.wp-block-real-world-learning-media .underline').append(discoverUnderline);
      }

      const circleDoodleTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.wp-block-real-world-learning-media.right-image',
          start: 'top 45%',
        },
      });

      circleDoodleTL
        .from('#circle-doodle .line', {
          drawSVG: '0%',
          duration: 0.35,
        });

      if ($('.wp-block-real-world-learning-media').hasClass('discover-their-potential')) {
        circleDoodleTL.from('#every-double-underline path', {
          drawSVG: '0%',
          duration: 0.3,
          stagger: 0.15,
        }, '-=.35');
      }

      if ($('#lightbulb').length) {
        circleDoodleTL.from('#bulb-path', {
          drawSVG: '0%',
          duration: 0.5,
        }).from('#lightbulb #line-1', {
          drawSVG: '0%',
          duration: 0.2,
        }, '-=.25').from('#lightbulb #line-2', {
          drawSVG: '0%',
          duration: 0.2,
        }, '-=.1').from('#lightbulb #line-3', {
          drawSVG: '0%',
          duration: 0.2,
        }, '-=.1')
          .from('#filament', {
            drawSVG: '0%',
            duration: 0.375,
          }, '-=.15')
          .from('#squiggle', {
            drawSVG: '0%',
            duration: 0.2,
          }, '-=.1')
          .from('#bottom', { opacity: 0, duration: 0.15 });
      }
    }

    if ($('.wp-block-real-world-learning-media.left-image').length) {
      const activateTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.wp-block-real-world-learning-media.left-image',
          start: 'top 50%',
        },
      });

      activateTL.from('#frame-doodle path', {
        drawSVG: '0%',
        duration: 0.4,
      }).from('#media-flare-doodle .segment-1', {
        drawSVG: '0%',
        duration: 0.25,
      }, '-=.2').from('#media-flare-doodle .segment-2', {
        drawSVG: '0%',
        duration: 0.1,
      }, '-=.15').from('#media-flare-doodle .segment-3', {
        drawSVG: '0%',
        duration: 0.1,
      })
        .from('#media-arrow .segment-1', {
          drawSVG: '0%',
          duration: 0.4,
        })
        .from('#media-arrow .segment-2', {
          drawSVG: '0%',
          duration: 0.25,
        })
        .from('#media-arrow .segment-3', {
          drawSVG: '0%',
          duration: 0.25,
        }, '-=.15');
    }

    if ($('.career-building').length) {
      const $cHighlight = $('#career-highlight');
      $('.career-building .highlight-underline').append($cHighlight);

      const careerTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.career-building',
          start: 'top 75%',
        },
      });

      careerTL.from('#career-highlight path', {
        drawSVG: '0%',
        duration: 0.35,
      });
    }

    if ($('.map-block').length) {
      const mapTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.map-block',
          start: 'top 75%',
        },
      });

      mapTL.from('#map-circle path', {
        drawSVG: '0%',
        duration: 0.25,
      }).from('#map-highlight path', {
        drawSVG: '0%',
        duration: 0.3,
      }, '.25');
    }

    if ($('.rwl-text-block').length) {
      const textBlockTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.rwl-text-block',
          start: 'top 70%',
        },
      });

      // Not showing up

      textBlockTL.from('#text-block-heading-underline .segment-1', {
        drawSVG: '0%',
        duration: 0.25,
      }).from('#text-block-heading-underline .segment-2', {
        drawSVG: '0%',
        duration: 0.25,
      }).from('#text-block-arrow .segment-1', {
        drawSVG: '0%',
        duration: 0.25,
      }).from('#text-block-arrow .segment-2', {
        drawSVG: '0%',
        duration: 0.1,
      })
        .from('#text-block-arrow .segment-3', {
          drawSVG: '0%',
          duration: 0.1,
        });

      if ($('.rwl-text-block').hasClass('is-style-approach')) {
        textBlockTL.from('#text-flare-doodle .segment-1', {
          drawSVG: '0%',
          duration: 0.25,
        }, '-=.2').from('#text-flare-doodle .segment-2', {
          drawSVG: '0%',
          duration: 0.1,
        }, '-=.15').from('#text-flare-doodle .segment-3', {
          drawSVG: '0%',
          duration: 0.1,
        });
      }
    }

    if ($('.testimonial-block').length) {
      const testimonialTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.testimonial-block',
          start: 'top 65%',
          onEnter() { document.querySelector('.testimonial-block').classList.add('animate'); },
        },
      });
    }

    if ($('.wp-block-real-world-learning-team-listing').length) {
      const teamTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.wp-block-real-world-learning-team-listing .component-heading',
          start: 'top 60%',
        },
      });

      const team2TL = gsap.timeline({
        scrollTrigger: {
          trigger: '.wp-block-real-world-learning-team-listing .intro-text-block',
          start: 'top center',
        },
      });

      teamTL
        .from('#team-flare .segment-1', {
          drawSVG: '0%',
          duration: 0.25,
        }, '-=.2').from('#team-flare .segment-2', {
          drawSVG: '0%',
          duration: 0.1,
        }, '-=.15').from('#team-flare .segment-3', {
          drawSVG: '0%',
          duration: 0.1,
        }).from('#team-arrow-1 .segment-1', {
          drawSVG: '0%',
          duration: 0.3,
        }, '.4')
        .from('#team-arrow-1 .segment-2', {
          drawSVG: '0%',
          duration: 0.1,
        }, '.8')
        .from('#team-arrow-1 .segment-3', {
          drawSVG: '0%',
          duration: 0.1,
        }, '1');

      team2TL.from('#team-arrow-2 .segment-1', {
        drawSVG: '0%',
        duration: 0.25,
      }).from('#team-arrow-2 .segment-2', {
        drawSVG: '0%',
        duration: 0.1,
      }).from('#team-arrow-2 .segment-3', {
        drawSVG: '0%',
        duration: 0.1,
      });
    }

    if ($('.collaborators-block').length) {
      const collabTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.collaborators-block',
          start: 'top center',
        },
      });

      collabTL
        .from('#collaborators-underline path', {
          drawSVG: '0%',
          duration: 0.3,
          stagger: 0.15,
        });
    }

    if ($('.wp-block-real-world-learning-executive-committee').length) {
      const execTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.wp-block-real-world-learning-executive-committee',
          start: 'top center',
        },
      });

      execTL.from('#executive-highlight path', {
        drawSVG: '0%',
        duration: 0.45,
      });
    }

    if ($('.wp-block-real-world-learning-champions ').length) {
      const champTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.wp-block-real-world-learning-champions',
          start: 'top center',
        },
      });

      champTL
        .from('#champions-circle path', {
          drawSVG: '0%',
          duration: 0.3,
        }).from('#champions-arrow .segment-1', {
          drawSVG: '0%',
          duration: 0.4,
        }).from('#champions-arrow .segment-2', {
          drawSVG: '0%',
          duration: 0.25,
        }).from('#champions-arrow .segment-3', {
          drawSVG: '0%',
          duration: 0.25,
        }, '-=.05');
    }

    if ($('.wp-block-real-world-learning-video').length) {
      const rwlVideoTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.wp-block-real-world-learning-video .component-heading',
          start: 'top 60%',
        },
      });

      rwlVideoTL
        .from('#rwl-video-highlight path', {
          drawSVG: '0%',
          duration: 0.3,
          stagger: 0.125,
        }).from('#video-underline path', {
          drawSVG: '0%',
          duration: 0.35,
        }, '-=.2');

      const rwlVideoTL2 = gsap.timeline({
        scrollTrigger: {
          trigger: '.wp-block-real-world-learning-video .rwl-video-introduction',
          start: 'top center',
        },
      });

      rwlVideoTL2.from('#rwl-video-arrow .segment-1', {
        drawSVG: '0%',
        duration: 0.25,
      }).from('#rwl-video-arrow .segment-2', {
        drawSVG: '0%',
        duration: 0.1,
      }).from('#rwl-video-arrow .segment-3', {
        drawSVG: '0%',
        duration: 0.1,
      });
    }

    if ($('.wp-block-real-world-learning-timeline').length) {
      const timelineTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.wp-block-real-world-learning-timeline',
          start: 'top 60%',
        },
      });

      timelineTL
        .from('.timeline-title-container line', {
          drawSVG: '0%',
          duration: 0.3,
          stagger: 0.15,
        });
    }
  }

  function errorPageAnimations() {
    const errorTL = gsap.timeline();

    errorTL
      .from('#error-highlight path', {
        drawSVG: '0%',
        duration: 0.2,
        stagger: 0.1,
      }).from('#error-underline .segment-1', {
        drawSVG: '0%',
        duration: 0.175,
      }).from('#error-underline .segment-2', {
        drawSVG: '0%',
        duration: 0.1,
      }).from('#error-underline .segment-3', {
        drawSVG: '0%',
        duration: 0.125,
      })
      .from('#error-arrow .segment-1', {
        drawSVG: '0%',
        duration: 0.3,
      })
      .from('#error-arrow .segment-2', {
        drawSVG: '0%',
        duration: 0.1,
      })
      .from('#error-arrow .segment-3', {
        drawSVG: '0%',
        duration: 0.1,
      });
  }

  function animateLightbulb() {
    const bulbTL = gsap.timeline({});

    bulbTL.from('#bulb-path', {
      drawSVG: '0%',
      duration: 0.5,
    }).from('#lightbulb #line-1', {
      drawSVG: '0%',
      duration: 0.2,
    }, '-=.25').from('#lightbulb #line-2', {
      drawSVG: '0%',
      duration: 0.2,
    }, '-=.1').from('#lightbulb #line-3', {
      drawSVG: '0%',
      duration: 0.2,
    }, '-=.1')
      .from('#filament', {
        drawSVG: '0%',
        duration: 0.375,
      }, '-=.15')
      .from('#squiggle', {
        drawSVG: '0%',
        duration: 0.2,
      }, '-=.1')
      .from('#bottom', { opacity: 0, duration: 0.15 })
      .from('#login-flare .segment-1', {
        drawSVG: '0%',
        duration: 0.35,
      })
      .from('#login-flare .segment-2', {
        drawSVG: '0%',
        duration: 0.1,
      })
      .from('#login-flare .segment-3', {
        drawSVG: '0%',
        duration: 0.1,
      })
      .from('#login-arrow .segment-1', {
        drawSVG: '0%',
        duration: 0.4,
      })
      .from('#login-arrow .segment-2', {
        drawSVG: '0%',
        duration: 0.25,
      })
      .from('#login-arrow .segment-3', {
        drawSVG: '0%',
        duration: 0.25,
      }, '-=.05')
      .from('#login-briefcase .segment-1', {
        drawSVG: '0%',
        duration: 0.25,
      })
      .from('#login-briefcase .segment-4', {
        drawSVG: '0%',
        duration: 0.15,
      }, '-=.15')
      .from('#login-briefcase .segment-2', {
        drawSVG: '0%',
        duration: 0.25,
      })
      .from('#login-briefcase .segment-3', {
        drawSVG: '0%',
        duration: 0.2,
      }, '-=.1')
      .from('#login-briefcase .segment-5, #login-briefcase .segment-6', {
        drawSVG: '0%',
        duration: 0.175,
      }, '-=.1')
      .from('#login-briefcase .segment-7', {
        drawSVG: '0%',
        duration: 0.15,
      });
  }

  // Run Animations if no reduced motion preference
  const mq = window.matchMedia('(prefers-reduced-motion: no-preference)');
  const screen = window.matchMedia('screen');

  if (mq.matches && screen.matches) {
    animatePolygons();
    componentAnimations();
  }

  const mapHighlight = $('#map-highlight');
  const mapCircle = $('#map-circle');
  const commitmentHighlight = $('#commitment-highlight');
  const executiveHighlight = $('#executive-highlight');
  const headingUnderline = $('#heading-underline');

  $('.map-block .text-block strong').append(mapHighlight);
  $('.map-block .text-block .highlight').append(mapCircle);
  $('.our-commitment .first-letter').append(commitmentHighlight);
  $('.our-commitment .word').append(headingUnderline);
  $('.wp-block-real-world-learning-executive-committee .highlight').append(executiveHighlight);

  if ($('body').hasClass('error404')) {
    if (mq.matches && screen.matches) {
      errorPageAnimations();
    }
  }

  if ($('body').hasClass('page-template-membership-login')) {
    if (mq.matches && screen.matches) {
      animateLightbulb();
    }
  }

  if ($('body').hasClass('single-post')) {
    if ($('.wp-block-gallery')) {
      $('.wp-block-gallery').slick({
        slide: 'figure',
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: false,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 599,
            settings: {
              dots: false,
              arrows: true,
            },
          },
        ],

      });
    }
  }

  if ($('body').hasClass('post-type-archive-resource')) {
    const resourceHighlight = $('#resource-single-underline');
    const resourceCircle = $('#resource-circle');
    const resourceUnderline = $('#resource-double-underline');
    $('.lede-text-block .highlight').append(resourceHighlight);
    $('.lede-text-block .circle').append(resourceCircle);
    $('.lede-text-block .underline').append(resourceUnderline);

    if (mq.matches && screen.matches) {
      const resourceTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.lede-text-block',
          start: 'top center',
        },
      });

      resourceTL.from('#resource-single-underline path', {
        drawSVG: '0%',
        duration: 0.3,
      }).from('#resource-circle path', {
        drawSVG: '0%',
        duration: 0.2,
      }).from('#resource-double-underline path', {
        drawSVG: '0%',
        duration: 0.3,
        stagger: 0.15,
      });
    }
  }

  if ($('body').hasClass('blog')) {
    const blogHighlight = $('#resource-single-underline');
    $('.lede-text-block .highlight').append(blogHighlight);

    if (mq.matches && screen.matches) {
      const blogTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.lede-text-block',
          start: 'top center',
        },
      });

      blogTL.from('#resource-single-underline path', {
        drawSVG: '0%',
        duration: 0.3,
      });
    }
  }

  if ($('body').hasClass('page-submit-resource')) {
    $('#not-author').on('click', () => {
      if ($(this).is(':checked')) {
        $('.not-author-field').addClass('show');
      } else if ($('.not-author-field').hasClass('show')) {
        $('.not-author-field').removeClass('show');
      }
    });

    $('[data-name="resource-type"] select').on('change', () => {
      const resourceType = $('[data-name="resource-type"] option:selected').text();

      if (resourceType === 'Video') {
        $('.streamed-video').addClass('show');
      } else if ($('.streamed-video').hasClass('show')) {
        $('.streamed-video').removeClass('show');
      }
    });
  }

  if ($('body').hasClass('page-team')) {
    const single = $('#single-underline-team');
    const double = $('#double-underline-team');

    $('.lede-text-block .highlight').append(single);
    $('.lede-text-block .underline').append(double);

    if (mq.matches && screen.matches) {
      const teamLedeTL = gsap.timeline({
        scrollTrigger: {
          trigger: '.lede-text-block',
          start: 'top center',
        },
      });

      teamLedeTL.from('.lede-text-block .highlight path', {
        drawSVG: '0%',
        duration: 0.25,
      }).from('.lede-text-block .underline path', {
        drawSVG: '0%',
        duration: 0.3,
        stagger: 0.15,
      });
    }
  }
});
